module.exports = new __parcel__URL__("plane_1_red.7236be4a.png").toString();